import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const ResizeIconNotes = (props) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      {...props}
    >
      <path d="M1 15L15 1" stroke="#BBBBBB" strokeWidth="2" />
      <path d="M5 16L16 5" stroke="#BBBBBB" strokeWidth="2" />
      <path d="M10 16L17 9" stroke="#BBBBBB" strokeWidth="2" />
    </SVG>
  )
}

export default withIconStyles(ResizeIconNotes)
